var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 115,
    r: 113.583,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.1947 143.119L52.1586 123.86V119.336L89.1947 100.077V105.562L58.4046 121.578L89.1947 137.634V143.119ZM130.396 83.0205L102.729 160.977H97.5244L125.111 83.0205H130.396ZM177.364 123.86L140.328 143.119V137.634L171.118 121.578L140.328 105.562V100.077L177.364 119.336V123.86Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCustom);
export default __webpack_public_path__ + "static/media/CodeCustom.074f54656e56172c6068d7e5c476a8f3.svg";
export { ForwardRef as ReactComponent };